import React from 'react';
import LazyLoad from 'react-lazyload';

interface NewProps {
  height?: string;
  placeholderHeight?: string;
  placeholderWidth?: string;
  srcDpr1: string;
  srcDpr2: string;
  width: string;
}

type ResponsiveImgDprProps = NewProps &
  Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'sizes' | 'srcSet' | 'src' | 'width' | 'height' | 'style'> & {
    style?: Omit<React.ImgHTMLAttributes<HTMLImageElement>['style'], 'width' | 'height'>;
  };

export const LazyImgDpr: React.FC<ResponsiveImgDprProps> = ({
  height,
  placeholderHeight,
  placeholderWidth,
  srcDpr1,
  srcDpr2,
  width,
  ...props
}) => {
  const srcSet = `
    ${srcDpr1},
    ${srcDpr2} 2x
  `;

  const { style } = props;

  return (
    <LazyLoad height={placeholderHeight || height} width={placeholderWidth || width}>
      <img sizes={width} src={srcDpr1} srcSet={srcSet} style={{ height, width, ...style }} {...props} />
    </LazyLoad>
  );
};
